import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      isLoading: false,

      login: async (username, password) => {
        set({ isLoading: true });
        try {
          const { data } = await api.post('/auth/login', { username, password });
          api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
          set({ token: data.token, user: data.user, isLoading: false });
          return data;
        } catch (err) {
          set({ isLoading: false });
          throw err;
        }
      },

      logout: async () => {
        try {
          await api.post('/auth/logout');
        } catch (_) {}
        delete api.defaults.headers.common['Authorization'];
        set({ token: null, user: null });
      },

      updateUser: (updates) => set(state => ({
        user: { ...state.user, ...updates },
      })),

      setToken: (token) => {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        set({ token });
      },
    }),
    {
      name: 'pbx-auth',
      partialize: (state) => ({ token: state.token, user: state.user }),
    }
  )
);
